import React from 'react';
import { DirectLine } from 'botframework-directlinejs';
import { SupportedProduct } from '../../botTypes';

export interface IDirectLineContextValue {
  directLine?: DirectLine;
  userid: string;
  username: string;
  endpoint: string;
  productName: SupportedProduct;
  isCustomStream: boolean;
}

export const DirectLineContext = React.createContext<IDirectLineContextValue | null>(null);
